import { render, staticRenderFns } from "./new-product.vue?vue&type=template&id=670b8ab6&scoped=true&"
import script from "./new-product.vue?vue&type=script&lang=js&"
export * from "./new-product.vue?vue&type=script&lang=js&"
import style0 from "./new-product.vue?vue&type=style&index=0&id=670b8ab6&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670b8ab6",
  null
  
)

export default component.exports